import { ActionIcon, Box, Group, Tooltip } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { resetReviewModeInRedux } from "./designSlice";
import { FaCheck } from "react-icons/fa";
import { MdClear } from "react-icons/md";
import React from "react";
import { HOTKEYS } from "../constants";

const ReviewBar: React.FC = () => {
  const review = useAppSelector((state) => state.design.review);
  const selectedRooms = useAppSelector((state) => state.design.selectedRooms);

  const dispatch = useAppDispatch();

  const isOnLast = review.currIndex + 1 === selectedRooms.length;
  return (
    <Group p={5} grow w="100%" gap="xs" bg="gray.3">
      <Group style={{ display: "flex", justifyContent: "center" }}>
        <Box p={2} bg="lightgray.1" style={{ borderRadius: "5px" }}>
          {review.currIndex + 1} / {selectedRooms.length}
        </Box>
        <Tooltip label={`Avbryt ${HOTKEYS.ABORT}`}>
          <ActionIcon
            variant="neutral"
            size="md"
            onClick={() => dispatch(resetReviewModeInRedux())}
          >
            {!isOnLast ? <MdClear /> : <FaCheck />}
          </ActionIcon>
        </Tooltip>
      </Group>
    </Group>
  );
};

export default ReviewBar;
